<footer>
    <ng-container *ngIf="isNotCountrySelectionPage$ | async">
        <ng-container *ngTemplateOutlet="doormat"></ng-container>
    </ng-container>
    <div class="copyline" *ngIf="footerData$ | async as footerData">
        <div class="container">
            <div class="copylinecontent">
                <div id="claim">
                    <img [src]="'images/claim/' + (site && site !== '' ? site : 'en_uk') + '.svg' | globalAsset" alt="{{ claim }}" />
                </div>
                <nav class="copylinenav">
                    <ng-container *ngIf="isPartnerPage$ | async">
                        <ng-container *ngTemplateOutlet="partnerFooter"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!(isPartnerPage$ | async)">
                        <ng-container *ngTemplateOutlet="regularFooter"></ng-container>
                    </ng-container>
                </nav>
            </div>
        </div>
    </div>
</footer>

<ng-template #partnerFooter>
    <ul class="reset" *ngIf="footerData$ | async as footerData">
        <li>{{ footerData.headline }} {{ currentYear }}</li>
        <ng-container *ngFor="let link of footerData.links">
            <li class="column" *ngIf="link.label && link.label !== ''">
                <a da-link [innerHTML]="link.label" [routerLink]="link.link | localize"></a>
            </li>
        </ng-container>
        <li *ngIf="portalImprintUrl && portalImprintUrl !== ''">
            <a [innerHTML]="'footer.imprint' | translate" target="_blank" href="{{portalImprintUrl}}"></a>
        </li>
        <li *ngIf="showCookiesData$ | async">
            <a da-link [innerHTML]="'popupTypeLinkLabel.cookiesSettings' | translate" (click)="openCookiesOverlay()"></a>
        </li>
    </ul>
</ng-template>

<ng-template #regularFooter>
    <ul class="reset" *ngIf="footerData$ | async as footerData">
        <li>{{ footerData.headline }} {{ currentYear }}</li>
        <li>
            <a id="data-protection" da-link [innerHTML]="'pageTypeLinkLabel.dataProtection' | translate" href="/dataprotection"></a>
        </li>
        <li>
            <a id="general-terms" da-link [innerHTML]="'pageTypeLinkLabel.terms' | translate" href="/generalterms"></a>
        </li>
        <li *ngIf="siteHasTranslationData('legalNotice')">
            <a da-link [innerHTML]="'pageTypeLinkLabel.legalNotice' | translate" href="/legalnotice"></a>
        </li>
        <li *ngIf="siteHasTranslationData('supplierIndentification')">
            <a da-link [innerHTML]="'pageTypeLinkLabel.supplierIndentification' | translate" href="/supplieridentification"></a>
        </li>
        <li *ngIf="siteHasTranslationData('transparency')">
            <a da-link [innerHTML]="'pageTypeLinkLabel.transparency' | translate" href="/transparencyselection"></a>
        </li>
        <li *ngIf="siteHasTranslationData('modernSlavery')">
            <a da-link [innerHTML]="'pageTypeLinkLabel.modernSlavery' | translate" href="/noticeselection"></a>
        </li>
        <li *ngIf="siteHasTranslationData('licenses')">
            <a da-link [innerHTML]="'pageTypeLinkLabel.licenses' | translate" href="/licensesselection"></a>
        </li>
        <li *ngIf="siteHasTranslationData('termsAndConditionsOfSale')">
            <a da-link [innerHTML]="'pageTypeLinkLabel.termsAndConditionsOfSale' | translate" href="/termsandconditionsofSaleselection"></a>
        </li>
        <li *ngIf="showCookiesData$ | async">
            <a da-link [innerHTML]="'popupTypeLinkLabel.cookiesSettings' | translate" (click)="openCookiesOverlay()"></a>
        </li>
    </ul>
</ng-template>

<ng-template #doormat>
    <div class="container" *ngIf="doormatData$ | async as doormatData">
        <button
        _ngcontent-wau-c95=""
        type="button"
        dw-button=""
        icon="drg-icon-level_up"
        themetype="Secondary"
        class="js-scroll-to-top button drg-icon-level_up secondary"
        tabindex="0"
        role="button"
        (click)="scrollToTop()"
    ></button>
        <h3 [innerHTML]="doormatData.headline"></h3>
        <div class="footercontent">
            <div class="column" *ngFor="let column of doormatData.columns">
                <ul class="reset">
                    <li>
                        <h6 class="small" [innerHTML]="column.title"></h6>
                    </li>
                    <li>
                        <a href="{{ column.link }}" [innerHTML]="column.text"></a>
                    </li>
                </ul>
            </div>
            <div class="column">
                <ul class="reset social">
                    <li *ngFor="let column of doormatData.social">
                        <a da-link="" target="_blank" href="{{ column.link }}" rel="noopener" data-dte-link-id="column.id">
                            <span class="drg-icon icon-md drg-icon-{{ column.iconName }}"></span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="column">
                <da-auto-complete-search-v3 *ngIf="showSearch$ | async" [config]="configSearch"></da-auto-complete-search-v3>
            </div>
        </div>
    </div>
</ng-template>
